import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';

import actions from '../actions';

//REDUCERS
const { step } = actions.customer;
export default handleActions(
  {
    [combineActions(step.next.toString(), step.change.toString(), step.prev.toString(), step.changeAlter.toString())]: (
      step,
      { payload }
    ) => {
      //no tinc clar q sigui correcta
      return payload ? step.set('current_step', fromJS(payload)) : step;
    },
    [step.initialize.toString()]: (step, { payload }) => {
      return payload;
    },
    [step.updateAlterStep.toString()]: (step, { payload }) => {
      return step.set('alter_list', payload);
    },
    [combineActions(step.jumpSteps.set.toString(), step.jumpSteps.remove.toString(), step.jumpSteps.clear.toString())]:
      (step, { payload }) => {
        return step.set('jump_steps', fromJS(payload));
      }
  },
  Map({
    loaded: false,
    current_step: null,
    list: List(),
    jump_steps: List()
  })
);
